import { isSchoolsReady } from "state/teachers/selectors";

/**
 * Get properties of the term with the given ID
 * @returns {Immutable.Map}
 */
export function getTermByID(state, termID) {
 return state.getIn(['teachers', 'terms', termID]);
}

/**
 * Get IDs of all terms for the given school, sorted by startDate
 * @returns {Immutable.Seq}
 */
export function getSchoolTermIDList(state, schoolID) {
  return state.getIn(['teachers', 'terms']).valueSeq()
    // filter for given school
    .filter((term) => term.get("schoolID") === schoolID)
    // sort by term start date
    .sortBy((term) => term.get("startDate"))
    .map((term) => term.get("id"))
}

/**
 * @returns {boolean}
 */
export function isTermsLoading(state) {
  return state.getIn(["teachers", "isTermsLoading"]);
}

/**
 * isMessagesReady - returns true if terms are loaded and ready
 * @returns {boolean}
 */
export function isTermsReady(state) {
  return isSchoolsReady(state) && !isTermsLoading(state);
}



// WEBPACK FOOTER //
// ./src/state/teachers/selectors/terms.js